"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChatOpened = exports.getChatAppId = exports.getAwinCookie = exports.getLeadData = exports.getPurchasedCartId = exports.getAtAtToken = exports.getUserId = exports.getVisitorId = exports.COOKIE_SS_ROUTE = exports.COOKIE_LEAD_CAPTURE_SUBMITTED = exports.COOKIE_AUTH0_AUTHENTICATED = exports.COOKIE_RETURN_TO_QW = exports.COOKIE_QW_RECOMMENDATIONS_SUBMITTED = exports.COOKIE_EMAIL = exports.COOKIE_MANDO_EXPIRES_TOKEN = exports.COOKIE_MANDO_TOKEN = exports.COOKIE_FLOATING_PROMO_WIDGET_CLOSED = exports.COOKIE_PARTNER_DATA = exports.COOKIE_STANDALONE_PRODUCT = exports.COOKIE_PROMO_SUBMITTED = exports.COOKIE_PROMO_MINIMIZED = exports.COOKIE_PROMO_DISMISSED = exports.COOKIE_BRAZE_PROMO_VIEWED = exports.COOKIE_BRAZE_SITE_VISITED = exports.COOKIE_AWIN_COOKIE = exports.COOKIE_USER_TOKEN = exports.COOKIE_CHAT_OPENED = exports.COOKIE_CHAT_APP_ID = exports.COOKIE_PREACTIVATION = exports.COOKIE_FCP_ORDER_ID = exports.COOKIE_PURCHASED_CART_ID = exports.COOKIE_LEAD_DATA = exports.COOKIE_ATAT_TOKEN = exports.COOKIE_VID = exports.COOKIE_DRUPAL_UID = void 0;
const initialize_1 = __importDefault(require("./initialize"));
exports.COOKIE_DRUPAL_UID = 'DRUPAL_UID';
exports.COOKIE_VID = 'vid';
exports.COOKIE_ATAT_TOKEN = 'atat_v2';
exports.COOKIE_LEAD_DATA = 'leadData';
exports.COOKIE_PURCHASED_CART_ID = 'purchasedCartId';
exports.COOKIE_FCP_ORDER_ID = 'FCP_ORDER_ID';
exports.COOKIE_PREACTIVATION = 'ssOauthAccessToken';
exports.COOKIE_CHAT_APP_ID = 'chat_app_id';
exports.COOKIE_CHAT_OPENED = 'chat_opened';
exports.COOKIE_USER_TOKEN = 'userToken';
exports.COOKIE_AWIN_COOKIE = 'awin_awc';
exports.COOKIE_BRAZE_SITE_VISITED = 'braze_site_visited_fired';
exports.COOKIE_BRAZE_PROMO_VIEWED = 'braze_promo_viewed';
exports.COOKIE_PROMO_DISMISSED = 'promobanner_isDismissed';
exports.COOKIE_PROMO_MINIMIZED = 'promobanner_isMinimized';
exports.COOKIE_PROMO_SUBMITTED = 'promobanner_isFormSubmitted';
exports.COOKIE_STANDALONE_PRODUCT = 'standAloneProduct';
exports.COOKIE_PARTNER_DATA = 'partners_data';
exports.COOKIE_FLOATING_PROMO_WIDGET_CLOSED = 'floating_promo_widget_closed';
exports.COOKIE_MANDO_TOKEN = 'ssOauthAccessToken'; // duplicate of COOKIE_PREACTIVATION
exports.COOKIE_MANDO_EXPIRES_TOKEN = 'ssOauthAccessExpires';
exports.COOKIE_EMAIL = 'email';
exports.COOKIE_QW_RECOMMENDATIONS_SUBMITTED = 'qw_recommendations_submitted';
exports.COOKIE_RETURN_TO_QW = 'ss_return_to_qw';
exports.COOKIE_AUTH0_AUTHENTICATED = 'auth0.is.authenticated';
exports.COOKIE_LEAD_CAPTURE_SUBMITTED = 'partnerBanner_isLeadCaptureSubmitted';
exports.COOKIE_SS_ROUTE = 'ss_route';
const getVisitorId = () => (0, initialize_1.default)().get(exports.COOKIE_VID) || '';
exports.getVisitorId = getVisitorId;
const getUserId = () => (0, initialize_1.default)().get(exports.COOKIE_DRUPAL_UID) || '';
exports.getUserId = getUserId;
const getAtAtToken = () => (0, initialize_1.default)().get(exports.COOKIE_ATAT_TOKEN);
exports.getAtAtToken = getAtAtToken;
const getPurchasedCartId = () => (0, initialize_1.default)().get(exports.COOKIE_PURCHASED_CART_ID) || '';
exports.getPurchasedCartId = getPurchasedCartId;
const getLeadData = () => (0, initialize_1.default)().get(exports.COOKIE_LEAD_DATA);
exports.getLeadData = getLeadData;
const getAwinCookie = () => (0, initialize_1.default)().get(exports.COOKIE_AWIN_COOKIE) || '';
exports.getAwinCookie = getAwinCookie;
const getChatAppId = () => (0, initialize_1.default)().get(exports.COOKIE_CHAT_APP_ID) || '';
exports.getChatAppId = getChatAppId;
const getChatOpened = () => (0, initialize_1.default)().get(exports.COOKIE_CHAT_OPENED) === 'true';
exports.getChatOpened = getChatOpened;
//# sourceMappingURL=index.js.map